import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import Ellipsis from "../icons/Ellipsis";

import { easingSeconds, colors } from "../shared";

const darkModeHover = `border-color: ${colors.veryLightPinkTwo};`;

const defaultFillColors = css`
    & path,
    & use,
    & g {
        transition: all ${easingSeconds};
        fill: ${({ transparent, active, isHeroSearchV2 }) => {
            if (active && transparent) return "#949494";
            if (active && isHeroSearchV2) return "#BABABA";
            if (active) return "#000000";
            if (transparent) return "#ffffff";
        }} !important;
    }

    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
                border: 1px solid transparent;
                border-radius: 50%;
                padding:  0.1875rem; // 3px
                width: 1.625rem; // 26px - design says 24px but we add 2 for the border
                height: 1.625rem; // 26px - design says 24px but we add 2 for the border
                transition: all ${easingSeconds};
            `}

    ${({ isHeroSearchV2, active }) =>
        isHeroSearchV2 && active && darkModeHover};
`;

defaultFillColors.propTypes = {
    transparent: PropTypes.bool,
    active: PropTypes.bool,
    isHeroSearchV2: PropTypes.bool
};

const hoverFillColors = css`
    &:hover {
        ${({ isHeroSearchV2 }) => isHeroSearchV2 && darkModeHover};
        & path,
        & use,
        & g {
            fill: ${({ transparent, isHeroSearchV2 }) =>
                transparent
                    ? colors.brownGrey
                    : isHeroSearchV2
                    ? colors.veryLightPinkTwo
                    : colors.black};
        }
    }
`;

hoverFillColors.propTypes = {
    transparent: PropTypes.bool,
    isHeroSearchV2: PropTypes.bool
};

export const TriggerButton = styled(Ellipsis)`
    width: 1.5rem;
    cursor: pointer;
    vertical-align: middle;

    ${defaultFillColors};
    ${hoverFillColors};
`;
